module.exports = __webpack_public_path__ + "static/media/hcpc.fe2b9c87.jpg";